// extracted by mini-css-extract-plugin
export default {"cls1":"uF0UepP1KetMNGvUE1NT","cls2":"EaaEYe4CdAKkGneuTqyJ uF0UepP1KetMNGvUE1NT"};